"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SVBButtonDropdown;
var _react = _interopRequireWildcard(require("react"));
var _reactBootstrap = require("react-bootstrap");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Global components
 * By Dharma Adusumilli <dadusumilli@svb.com> (www.svb.com)
 * Summary
 * This component renders a SVB button with dropdown
 */

function SVBButtonDropdown(props) {
  const {
    text,
    data,
    icon,
    onOptionClick
  } = props;
  const DDButton = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
    let {
      children,
      onClick: _onClick
    } = _ref;
    return /*#__PURE__*/_react.default.createElement("a", {
      href: "",
      ref: ref,
      onClick: e => {
        e.preventDefault();
        _onClick(e);
      }
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "cta-icon"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: icon,
      width: "24"
    })), children);
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown, {
    className: "svb-button-with-dropdown"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Toggle, {
    as: DDButton
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "svb-dropdown-button-text"
  }, text), /*#__PURE__*/_react.default.createElement("i", {
    className: "fa fa-chevron-down"
  })), data ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Menu, null, data === null || data === void 0 ? void 0 : data.map(option => /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
    key: option === null || option === void 0 ? void 0 : option.label,
    onClick: () => onOptionClick(option)
  }, option === null || option === void 0 ? void 0 : option.label))) : ''));
}
;